import LeaveTypesView  from "../LeaveTypesView.vue";
import LeaveTypeList    from "../Pages/LeaveTypeList.vue";
import LeaveTypeEditor  from "../Pages/LeaveTypeEditor.vue";

const routes = [
  {
    path: "/mantenimiento/tipos-licencia",
    component: LeaveTypesView,
    children: [
      {
        path: "",
        name: "leave-type-list",
        component: LeaveTypeList,
      },
      {
        path: "crear",
        name: "leave-type-create",
        component: LeaveTypeEditor,
      },
      {
        path: ":id/editar",
        name: "leave-type-edit",
        component: LeaveTypeEditor,
      },
    ],
  },
];

export default routes;
